import { ActionType } from "../actions/ActionTypes";
// import { Action } from "../actions";

export interface UserState {
  user: any;
  error: string;
  loading: boolean;
  feedbackGiven:boolean;
}

const initialState: UserState = {
  user: {},
  error: "",
  loading: false,
  feedbackGiven:false,
};

const reducer = (state: object = initialState, action: any): any => {
  switch (action.type) {
    case ActionType.GET_USER_PROFILE_INIT:
      return {
        ...state,
        error: "",
        loading: true,
      };
    case ActionType.GET_USER_PROFILE_SUCCESS:
      return {
        ...state,
        user: action.payload,
        loading: false,
        feedbackGiven: action.payload.feedbackGiven||false,
      };
    case ActionType.GET_USER_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

      case ActionType.UPDATE_USER_PROFILE_INIT:
      return {
        ...state,
        error: "",
        loading: true,
      };
    case ActionType.UPDATE_USER_PROFILE_SUCCESS:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };
    case ActionType.UPDATE_USER_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
      
    default:
      return state;
  }
};

export default reducer;
